<app-dialog [title]="title">
  <div content>
    <div class="flex align-items-center justify-content-start gap-1 lg:gap-3">
      <div>
        <mat-icon [ngClass]="color" class="material-symbols-outlined lg-icon-size">{{icon}}</mat-icon>
      </div>
      <div>{{message}}</div>
    </div>
  </div>
  <div class="flex gap-3 p-2" footer>
    <app-button (click)="onAcceptButtonClick()" [color]="acceptButton.color" [icon]="acceptButton.icon"
                [label]="acceptButtonLabel()" [raised]="acceptButton.raised" cdkFocusRegionstart/>
  </div>
</app-dialog>
